export default __webpack_public_path__ + "static/media/alex9.f270e67e.jpg";